import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const useFAQSCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        FAQSPage: {
          pageTitle: t('faqs_page:page_title'),
          pageDescription: t('faqs_page:page_description'),
          startReservation: t('faqs_page:start_reservation'),
          rentalFaqs: t('faqs_page:rental_faqs'),
          selfDriveFaqs: t('faqs_page:self_drive_faqs'),
          guidedFaqs: t('faqs_page:guided_faqs'),
          membershipFaqs: t('faqs_page:membership_faqs'),
          rewardsFaqs: t('faqs_page:rewards_faqs'),
          membershipEGiftCardsFaqs: t('faqs_page:membership_e_gift_cards_faqs'),
          eGiftCardsFaqs: t('faqs_page:e_gift_cards_faqs'),
          offroadFaqs :t('faqs_page:offroad_faqs'),
          searchPlaceholder: t('faqs_page:search_faqs_placeholder'),
          back: t('faqs_page:back'),
          information: t('faqs_page:information'),
          resultsFor: t('faqs_page:results_for'),
          eagleRiderLabel: t('faqs_page:EagleRider'),
          faqs: t('faqs_page:FAQs'),
          rental: t('faqs_page:rental'),
          selfDrive: t('faqs_page:self_drive'),
          guided: t('faqs_page:guided'),
          membership: t('faqs_page:membership'),
          rewards: t('faqs_page:rewards'),
          membershipEGiftCards: t('faqs_page:membership_e_gift_cards'),
          eGiftCards: t('faqs_page:e_gift_cards'),
          offroad: t('faqs_page:offroad'),
        },
      },
    }),
    [t],
  );

  return data;
};

export { useFAQSCMSData };
